export const photos = [
    { 
        src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bg-1.png`,
      },
      { 
        src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-1.png`,
      },
      { 
        src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bg-2.png`,
      },
      { 
        src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-2.png`,
      },
      

  ];